import store from '@/store'
export default function (catId) {
    const categories    = store.state.blog.category
    const selectedCategory = categories.filter((cat) => cat.id === Number(catId))
    return selectedCategory[0]
}